import React from 'react';
import {IconProps} from './IconProps';

export default function IconCaretDown({className, height}: IconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 10 6"
      fill="none"
      stroke="currentColor"
      height={height||6}
    >
      <path d="M0.96875 0C0.40625 0 0.125 0.6875 0.53125 1.09375L4.53125 5.09375C4.78125 5.34375 5.1875 5.34375 5.4375 5.09375L9.4375 1.09375C9.84375 0.6875 9.5625 0 9 0H0.96875Z" fill="currentColor"/>
    </svg>
  );
}
